<template>
    <div class="utility-callout-wrapper w-w270 flex lg:flex-col lg:ml-0 items-center  mb-spc16 sm:flex-row sm:ml-auto sm:mr-auto">
        <div class="callout-item relative lg:py-10 sm:py-0 w-full lg:justify-start sm:justify-center lg:text-left sm:text-center">
            <h1 class="callout-title flex items-end text-size28 font-semibold text-primary h-12 lg:justify-start sm:justify-center">
                360°
            </h1>
            <p class="callout-desc text-xs font-medium leading-spc3 lg:block sm:hidden">
                Rear, side and forward-facing cameras provide maximum visibility
            </p>
            <p class="callout-desc rp text-xs font-medium leading-spc3 lg:hidden sm:block">
                Degrees <br>of visibility
            </p>
        </div>
        <div class="callout-item relative lg:py-10 sm:py-0 w-full lg:justify-start sm:justify-center lg:text-left sm:text-center">
            <h1 class="callout-title flex items-center text-size28 font-semibold text-primary lg:justify-start sm:justify-center h-12">
                160
                <span class="pl-1">m</span>
            </h1>
            <p class="callout-desc text-xs font-medium leading-spc3 lg:block sm:hidden">
                Forward-facing radar provides a long-range view of distant objects
            </p>
            <p class="callout-desc rp text-xs font-medium leading-spc3 lg:hidden sm:block">
                of Forward <br>Protection
            </p>
        </div>
        <div class="callout-item relative lg:py-10 sm:py-0 w-full lg:justify-start sm:justify-center lg:text-left sm:text-center">
            <h1 class="callout-title flex items-center text-14 h-12 lg:justify-start sm:justify-center lg:mb-2 sm:mb-0">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="41px" height="40px" viewBox="0 0 41 40">
                    <title>autopilot</title>
                    <desc>Created with Sketch.</desc>
                    <g id="autopilot-area" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="ultrasonic-Sensors" transform="translate(-1.000000, 0.000000)" fill="#000000" fill-rule="nonzero">
                            <path d="M21.6,40 L21.2,40 C10.1333333,40 1.2,31.0666667 1.2,20 C1.2,8.93333333 10.1333333,0 21.2,0 L21.6,0 C32.6666667,0 41.6,8.93333333 41.6,20 C41.6,31.0666667 32.5333333,40 21.6,40 Z M21.0666667,1.33333333 C10.8,1.33333333 2.4,9.73333333 2.4,20 C2.4,30.2666667 10.8,38.6666667 21.0666667,38.6666667 L21.4666667,38.6666667 C31.7333333,38.6666667 40.1333333,30.2666667 40.1333333,20 C40.1333333,9.73333333 31.7333333,1.33333333 21.4666667,1.33333333 L21.0666667,1.33333333 Z" id="Shape"/>
                            <polygon id="Path" points="13.6 27.7333333 16.9333333 27.7333333 16.9333333 12 14.5333333 12 10 13.3333333 10.6666667 16.1333333 13.3333333 15.4666667 13.3333333 27.7333333 13.6 27.7333333"/>
                            <path d="M19.7333333,27.7333333 L31.3333333,27.7333333 L31.3333333,24.8 L24.5333333,24.8 L27.0666667,22.8 C29.8666667,20.6666667 31.2,19.3333333 31.2,16.8 L31.2,16.8 C31.2,13.8666667 29.0666667,12 25.8666667,12 C23.0666667,12 21.6,13.2 20,15.2 L22.4,17.2 C23.6,15.7333333 24.4,15.0666667 25.6,15.0666667 C26.8,15.0666667 27.7333333,15.7333333 27.7333333,17.0666667 C27.7333333,18.4 26.9333333,19.2 25.0666667,20.8 L19.8666667,25.0666667 L19.7333333,27.7333333 L19.7333333,27.7333333 Z" id="Path"/>
                        </g>
                    </g>
                </svg>
                <span class="block text-14 font-medium pl-1 lg:block sm:hidden">
                    Ultrasonic <br>Sensors
                </span>
            </h1>
            <p class="callout-desc text-xs font-medium leading-spc3 lg:block sm:hidden">
                Detect nearby cars, prevent potential collisions and assist with parking
            </p>
            <p class="callout-desc rp text-xs font-medium leading-spc3 lg:hidden sm:block">
                Ultrasonic <br>Sensors
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AutopilotSpecs"
    }
</script>

<style scoped>

</style>